module.exports = __webpack_public_path__ + "static/media/P1000_Tip_Box.7b6cfb22.svg";